import React, {useState, useEffect} from 'react'

import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import RateReviewIcon from '@material-ui/icons/RateReview';
import WebIcon from '@material-ui/icons/Web';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import { Prerequisites, WorkflowData, Migration } from './WorkflowData'

import AOS from "aos";
import "aos/dist/aos.css";

const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: 150,
      padding: "0",
      margin: "0",
    },
    selectInput: {
        color: "#fff"
    }
  }));

const Workflow = () => {
    const classes = useStyles();
    const [selectedRole, setSelectedRole] = useState([])
    const [time, setTime] = useState('')
    const [prerequisites, setPrerequisites] = useState(Prerequisites);
    const [workflow, setWorkflow] = useState(WorkflowData)
    const [migration, setMigration] = useState(Migration)
    const [creatorTasks, setCreatorTasks] = useState(0)
    const [testerTasks, setTesterTasks] = useState(0)
    const [adminTasks, setAdminTasks] = useState(0)

    useEffect(() => {
        AOS.init({
          duration: 1500,
        });
        countTasks()
    }, []);

    const countTasks = () => {
        const creators = document.getElementsByClassName('creator');
        setCreatorTasks(creators.length);
        const testers = document.getElementsByClassName('tester')
        setTesterTasks(testers.length)
        const admins = document.getElementsByClassName('admin')
        setAdminTasks(admins.length)
    }

    const setRoleColor = (arr) => {
        selectedRole.forEach((role) => {
            const result = document.getElementsByClassName(role)
            if(role === 'creator') {
                for(let i=0; i<result.length; i++) {
                    result[i].style.color = 'red'
                }
            } else if (role === 'tester') {
                for(let i=0; i<result.length; i++) {
                    result[i].style.color = 'yellow'
                }
            } else if (role === 'admin') {
                for(let i=0; i<result.length; i++) {
                    result[i].style.color = 'green'
                }
            }
        })
    }

    const removeRoleColor = (role) => {
        const result = document.getElementsByClassName(role)
        for(let i=0; i<result.length; i++) {
            result[i].style.color = '#000'
        }
    }

    const handleMultiRole = (e, role) => {
        let selected = selectedRole;
        if (!selected.includes(role)) {
            if (role === 'creator') {
                const el = document.getElementById('Workflow_btn_creator')
                el.style.border = '4px solid red'
            } else if (role === 'tester') {
                const el = document.getElementById('Workflow_btn_tester')
                el.style.border = '4px solid yellow'
            } else if (role === 'admin') {
                const el = document.getElementById('Workflow_btn_admin')
                el.style.border = '4px solid green'
            }
            selected.push(role)
            setSelectedRole(selected)
            setRoleColor(selected)
        } else {
            if (role === 'creator') {
                const el = document.getElementById('Workflow_btn_creator')
                el.style.border = '4px solid transparent';
            } else if (role === 'tester') {
                const el = document.getElementById('Workflow_btn_tester')
                el.style.border = '4px solid transparent'
            } else if (role === 'admin') {
                const el = document.getElementById('Workflow_btn_admin')
                el.style.border = '4px solid transparent'
            }
            selected = selected.filter(el => el !== role);
            setSelectedRole(selected)
            removeRoleColor(role)
        }
    }

    const handleTimeChange = (e) => {
        setTime(e.target.value)
        const time = e.target.value;
        if (time === 'all') {
            setPrerequisites(Prerequisites);
            setWorkflow(WorkflowData);
            setMigration(Migration);
            resetDefaults()
        } else {
            const flow1 = [];
            const flow2 = [];
            const flow3 = [];
            Prerequisites.forEach(item => {
                if (item.time == time) {
                    flow1.push({
                        ...item,
                        html: <div className="time_steps">{item.html}</div>,
                    })
                } else {
                    flow1.push({
                        ...item,
                        html: <div className="Workflow_steps">{item.html}</div>
                    })
                }
            })
           WorkflowData.forEach(item => {
                if (item.time == time) {
                    flow2.push({
                        ...item,
                        html: <div className="time_steps">{item.html}</div>,
                    })
                } else {
                    flow2.push({
                        ...item,
                        html: <div className="Workflow_steps">{item.html}</div>
                    })
                }
            })
            Migration.forEach(item => {
                if (item.time == time) {
                    flow3.push({
                        ...item,
                        html: <div className="time_steps">{item.html}</div>,
                    })
                } else {
                    flow3.push({
                        ...item,
                        html: <div className="Workflow_steps">{item.html}</div>
                    })
                }
            })
            setPrerequisites(flow1);
            setWorkflow(flow2);
            setMigration(flow3);
            resetDefaults()
        }
    }

    const resetDefaults = () => {
        setSelectedRole([])
        const el1 = document.getElementById('Workflow_btn_creator')
        el1.style.border = '4px solid transparent';
        const el2 = document.getElementById('Workflow_btn_tester')
        el2.style.border = '4px solid transparent';
        const el3 = document.getElementById('Workflow_btn_admin')
        el3.style.border = '4px solid transparent';
        removeRoleColor('creator')
        removeRoleColor('tester')
        removeRoleColor('admin')
    }

    return (
        <div id="Workflow">
            <div className="Workflow_heading">
                <h2 className="Workflow--title">
                    Taking your Zips live
                </h2>
            </div>
            <div className="Workflow_filter">
                <h3>Filter By Role: </h3>
                <div className="Workflow_btnGroup">
                    <button id="Workflow_btn_creator" className="Workflow_btn" onClick={(e) => handleMultiRole(e, 'creator')}>
                        <RateReviewIcon className="Workflow_btn_icon" />
                        <div className="Workflow_btn_text">Creators {creatorTasks && `(${creatorTasks})`}</div>
                    </button>
                    <button id="Workflow_btn_tester" className="Workflow_btn" onClick={(e) => handleMultiRole(e, 'tester')}>
                        <PlayCircleFilledIcon className="Workflow_btn_icon" />
                        <div className="Workflow_btn_text">Testers {testerTasks && `(${testerTasks})`}</div>
                    </button>
                    <button id="Workflow_btn_admin" className="Workflow_btn" onClick={(e) => handleMultiRole(e, 'admin')}>
                        <WebIcon className="Workflow_btn_icon" />
                        <div className="Workflow_btn_text">Admins {adminTasks && `(${adminTasks})`}</div>
                    </button>
                </div>
                <h3>Filter by Time:</h3>
                <div className="Workflow_btnGroup">
                    <button className="Workflow_btn">
                        <AccessTimeIcon className="Workflow_btn_icon" />
                        <form className="Workflow_time">
                            <select name="time" id="time" onChange={handleTimeChange}>
                            <option value="all">All</option>
                            <option value={5}>5 mins</option>
                            <option value={10}>10 mins</option>
                            <option value={15}>15 mins</option>
                            </select>
                        </form>
                    </button>
                </div>
            </div>
            <div className="Workflow_list">
                <div className="Workflow_item">
                    <div className="Workflow_name">
                        <h3>1. &nbsp;Prerequisites (45 mins)</h3>
                        {
                            prerequisites.map((item, id) => {
                                return (
                                    <div key={id} className="Workflow_item_main">
                                        <div className="Workflow_step_container">
                                            {item.html}
                                        </div>
                                        {
                                            item.time && <div className="Workflow_item_hover">
                                                <AccessTimeIcon className="Workflow_hover_icon" />
                                                <p className="Workflow_hover_text">{item.time} mins</p>
                                            </div>
                                        }
                                        {
                                            id < prerequisites.length - 1 && <div className="Workflow_line"></div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="Workflow_item">
                    <div className="Workflow_name">
                        <h3>2. &nbsp;Workflow (60 mins)</h3>
                        {
                            workflow.map((item, id) => {
                                return (
                                    <div key={id} className="Workflow_item_main">
                                        <div className="Workflow_step_container">
                                            {item.html}
                                        </div>
                                        {
                                            item.time && <div className="Workflow_item_hover">
                                                <AccessTimeIcon className="Workflow_hover_icon" />
                                                <p className="Workflow_hover_text">{item.time} mins</p>
                                            </div>
                                        }
                                        {
                                            id < workflow.length - 1 && <div className="Workflow_line"></div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="Workflow_item">
                    <div className="Workflow_name">
                        <h3>3. &nbsp;Migration and Production Live (30 mins)</h3>
                        {
                            migration.map((item, id) => {
                                return (
                                    <div key={id} className="Workflow_item_main">
                                        <div className="Workflow_step_container">
                                            {item.html}
                                        </div>
                                        {
                                            item.time && <div className="Workflow_item_hover">
                                                <AccessTimeIcon className="Workflow_hover_icon" />
                                                <p className="Workflow_hover_text">{item.time} mins</p>
                                            </div>
                                        }
                                        {
                                            id < migration.length - 1 && <div className="Workflow_line"></div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Workflow
